var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.071,2.929a10,10,0,1,0,0,14.143A10,10,0,0,0,17.071,2.929ZM11.3,14.348a1.3,1.3,0,0,1-2.609,0V9.13a1.3,1.3,0,1,1,2.609,0ZM9.977,6.9A1.163,1.163,0,0,1,8.74,5.712a1.163,1.163,0,0,1,1.252-1.2A1.2,1.2,0,1,1,9.977,6.9Z",
    transform: "translate(0 0)",
    fill: "#112c5a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.276de010f242d03d145dfb44b09f6651.svg";
export { ForwardRef as ReactComponent };